<template>
    <f7-page name="video-message">
        <bc-navbar></bc-navbar>
        <div style="-webkit-touch-callout: none; height: 100%; overflow-y: auto; width: 100%;">
            <div v-bind:class="{ none: !isRequestActive }" class="loader"> 
                <looping-rhombuses-spinner :animation-duration="2500" :rhombus-size="15" color="#f9f300" />
            </div>
            <div class="layout_fullwidth_padding" id="focusDiv" v-for="(vmessage,key) in videoMessages" :key="key" v-on:click="selectVideo(vmessage.videoMessageId)">
                <h3>Video Messages</h3>
                <div v-if="vmessage.youTubeId||vmessage.thumbnail"   class="thumbnail-container">
                    <div class="play-button">
                        <img style="width:25px;height:25px" src="/static/images/play_button.png"/>             
                    </div>
                        <img v-if="vmessage.youTubeId" :src="'https://img.youtube.com/vi/'+vmessage.youTubeId+'/0.jpg'"/>
                    <img v-if="vmessage.url && !vmessage.youTubeId" :src="vmessage.thumbnail"/>
                </div>
                <div class="video_message_title" :style="{'background-color':customization.mainColor }" >
                    <h5 :style="{ 'color': customization.fontColor}">{{vmessage.title}}</h5>
                    <h6 :style="{ 'color': customization.fontColor}">Sent On {{getDateAndTime(vmessage.sentDate)}}</h6>
                </div>
            </div>
        </div>
    </f7-page>
</template>

<script>
/* eslint-disable */
import { mapState,mapGetters,mapActions } from 'vuex'
import { LoopingRhombusesSpinner  } from 'epic-spinners'

export default {
    components:{
        LoopingRhombusesSpinner 
    },
    mounted:function(){
        this.isRequestActive = true;
        this.$store.dispatch('videoMessage/loadVideoMessages')
            .then(()=>{
                console.log(this.videoMessages);
                //this.isRequestActive =false;
                this.$nextTick(() => {
                    this.isRequestActive = false;
                })
            }).catch(x=> {
      this.$f7.mainView.router.load({url: 'error'});
    });
    },
    updated:function(){
    },
    computed:{    
     ...mapState({
        videoMessages: state => state.videoMessage.videoMessages,
        customization:state=>state.common.customization,
    }),
    borderStyle: function(){     
      var borderStyle = this.customization.borderOn ? 'solid 1px ' + this.customization.borderColor :  'none';
      var backgroundStyle = this.customization.mainColor;
      var colorStyle = this.customization.fontColor
      return {
        border: borderStyle, 
        background: backgroundStyle,
        color:colorStyle
      };
     }
    },
    methods: {
        selectVideo(id)
        {
            this.$router.load({url:"video-message/"+id});
            console.log(this.$router);
        },
        getDateAndTime(rawData)
        {
            var date = new Date(rawData);
            return (date.getMonth()+1)+"/"+date.getDate()+"/"+date.getFullYear();
        }
    },
    data() {
        return{
            isRequestActive:false
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.thumbnail-container{
    width: 100%;
    position: relative;
}
.play-button{
    width: 100%;
    height: 100%;
    position:absolute;
    display: flex;
    align-items: center;
    justify-content: center;
}

img{
        width:100%;
        max-height:640px;
        object-fit: cover;
    }
@media screen and (max-width: 768px){
    img{
        width:100%;
        max-height:250px;
        object-fit: cover;

    }
}

.button_full{
    margin-top:20px 
}
select
{
    width: 100%;
    height: 35px;
}
h5{
    font-weight: bold;
    padding: 10px 0 10px 0;
}
.loader{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background:  rgb(255, 255, 255);
    z-index: 9999999;
}
.none{
    display: none;
}
.video_message_title
{
    width: 95%;
    font-size: 16px;
    line-height: 25px;
    font-weight: 300;
    padding: 10px 0 10px 5%;
    margin: 0px 0 15px 0;
    background-color: #f9f301;
    display: inline-block;
    letter-spacing: -0.5px;
}
body{
    overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// video-message.vue?6e97e5c2